export enum Tier {
  Blue = 1,
  Bronze,
  Silver,
  Gold,
  Diamond,
  Black
}

export type ChestHistory = {
  earnedOnTime: string; // datetime "2023-03-21T16:30:12",
  validUntilTime: string; // datetime "2023-04-18T16:30:12"
}[];

export interface CvlConfig {
  boostEnabled: boolean;
  canExchange: boolean;
  cvl2: boolean;
  daysToExpire: number;
  exchangePercent: number;
  expiresOn: string; // datestamp "2022-09-06T18:59:07"
  goingToTierDown: boolean;
  goingToTierUp: boolean;
  recentBarCounter: number;
  showTierDownExchange: boolean;
  showTierDownPopUp: boolean;
  showTierUpPopUp: boolean;
  startedOn: string; // datestamp "2022-06-08T18:59:07"
  tierDownDays: number;
  tierUpBars: number;
  tierUpDays: number;
  timezone: string; // "ET"
  totalDoneBarCount: number;
  chestHistory: ChestHistory; // fix types
}

export const defaultCvlConfig = {
  boostEnabled: false,
  canExchange: false,
  cvl2: true,
  daysToExpire: 0,
  exchangePercent: 0,
  expiresOn: '',
  goingToTierDown: false,
  goingToTierUp: false,
  recentBarCounter: 0,
  showTierDownExchange: false,
  showTierDownPopUp: false,
  showTierUpPopUp: false,
  startedOn: '',
  tierDownDays: 0,
  tierUpBars: 0,
  tierUpDays: 0,
  timezone: '',
  totalDoneBarCount: 0,
  chestHistory: []
};

export interface CvlBar {
  boostRemaining: number;
  chestsCount: number;
  currentPoints: number;
  excludedFromSR: boolean;
  excludedUser: boolean;
  goingToTierDown: boolean;
  goingToTierUp: boolean;
  hideChests: boolean;
  nextBoostTimeHours: number;
  nextBoostTimeMinutes: number;
  optinNotificationActive: boolean;
  showTierUp: boolean;
  starCoinBalance: number;
  targetPoints: number;
  tierId: Tier;
  tierUpEndHours: number;
  tierUpEndMinutes: number;
  userExcluded: boolean;
  userOptedIn: boolean;
}

export const defaultCvlBar = {
  boostRemaining: 0,
  chestsCount: 0,
  currentPoints: 0,
  excludedFromSR: false,
  excludedUser: false,
  goingToTierDown: false,
  goingToTierUp: false,
  hideChests: false,
  nextBoostTimeHours: 0,
  nextBoostTimeMinutes: 0,
  optinNotificationActive: false,
  showTierUp: false,
  starCoinBalance: 0,
  targetPoints: 0,
  tierId: Tier.Blue,
  tierUpEndHours: 0,
  tierUpEndMinutes: 0,
  userExcluded: false,
  userOptedIn: false
};

export interface RewardsStateModel {
  cvlBar?: CvlBar;
  cvlConfig?: CvlConfig;
}
